export default __webpack_public_path__ + "static/media/notintroduce.3ade2243.png";